<template>
    <v-dialog
        v-model="showModal"
        transition="dialog-top-transition"
        max-width="500"
        persistent
    >
        <div class="position-relative" style="position:relative;">
            <div class="text-right">
                <v-btn
                    style="position:absolute;right:0;top:0;z-index:9;"
                    icon
                    color="white"
                    @click="closeModal"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <v-card
                color="white"
                class="overflow-hidden"
                :class="{ 'fireworks':correctAnswer }"
            >
                <div class="fireworks__before"></div>
                <div class="fireworks__after"></div>
                <v-sheet
                    v-if="correctAnswer"
                    class="green darken-2 mb-4"
                    dark
                >
                    <v-card-title class="text-h5 font-weight-bold pb-4">
                        Success! 👏
                    </v-card-title>
                    <v-card-subtitle class="text-sm-caption pb-2">
                        You guessed the movie correctly! <v-icon class="ml-1 mb-1" small>mdi-check-outline</v-icon>
                    </v-card-subtitle>
                </v-sheet>
                <v-sheet
                    v-else
                    class="red darken-4 mb-4"
                    dark
                >
                    <v-card-title class="text-h5 font-weight-bold pb-4">
                        Wrong Answer 😔
                    </v-card-title>
                    <v-card-subtitle class="text-sm-caption pb-2">
                        You guessed: <v-chip color="red darken-1" small>{{ guess }}</v-chip>
                    </v-card-subtitle>
                </v-sheet>

                <v-card-text class="pt-3 pb-5">
                    <h3 class="mb-3">{{ title }}</h3>
                    <div class="d-flex flex-nowrap">
                        <!-- lEFT: Image -->
                        <div class="mr-3">
                            <v-sheet
                                color="grey lighten-2"
                                width="125"
                                height="185"
                                elevation="5"
                            >
                                <div v-if="movieImgSrc && title">
                                    <!-- <v-img :src="movieImgSrc"></v-img> -->
                                    <img :src="movieImgSrc" style="width:100%;">
                                </div>
                                <div v-else>
                                    <v-icon color="white" large>
                                        mdi-filmstrip <!-- mdi-wallpaper / mdi-image-->
                                    </v-icon>
                                </div>
                            </v-sheet>
                        </div>
                        <!-- RIGHT: Info Year Actor(s) -->
                        <div>
                            <div class="d-flex align-center">
                                <div class="mr-3">Year: </div>
                                <transition name="fade" mode="out-in">
                                    <div v-if="hintYear" key="display-movie-year-as-hintYear">
                                        <div>{{ hintYear }}</div>
                                    </div>
                                </transition>
                            </div>
                            <div class="mt-5">
                                <div class="mr-3">Actor(s): </div>
                                <transition name="fade" mode="out-in">
                                    <div v-if="hintActor" key="display-movie-year-as-hintActor">
                                        <div>{{ hintActor }}</div>
                                    </div>
                                </transition>
                            </div>
                            <!-- DIFFICULTY -->
                            <div class="mt-5">
                                <div class="mr-3">Difficulty: </div>
                                <transition name="fade" mode="out-in">
                                    <div
                                        v-if="difficulty && difficultyObject"
                                        :key="`difficulty-quote-${selectedQuoteIndex}`"
                                        class="d-inline-flex align-items-center"
                                    >
                                        <div>
                                            <v-chip
                                                :color="difficultyObject.color"
                                                outlined
                                                small
                                            >
                                                <v-icon small>
                                                    mdi-{{ difficultyObject.icon }}
                                                </v-icon>
                                                <span class="ml-1">{{ difficulty }}</span>
                                            </v-chip>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                    <div>
                        <!-- IMDB URL -->
                        <div class="text-center mt-4">
                            <a
                                :href="`https://www.imdb.com/title/${imdbId}/`"
                                :title="title"
                                target="_blank"
                                class="text-decoration-none border-bottom"
                                style="border-bottom:1px solid;"
                            >
                                View this on IMDB.com
                                <v-icon
                                    color="primary"
                                    small
                                    class="mb-1"
                                >
                                    mdi-share
                                </v-icon>
                            </a>
                        </div>
                    </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        ref="focusBtn"
                        color="primary"
                        @click="closeModal"
                        @keydown.enter="closeModal"
                    >
                        New Quote
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
    </v-dialog>
</template>

<script>
    export default {
        data() {
            return {
                showModal: true,
            };
        },

        props: {
            correctAnswer: {
                type: Boolean,
                required: true,
            },
            guess: {
                type: String,
                required: true,
            },
            movieImgSrc: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            hintYear: {
                type: String,
                required: true,
            },
            hintActor: {
                type: String,
                required: true,
            },
            difficulty: {
                type: String,
                required: true,
            },
            difficultyObject: {
                type: Object,
                required: true,
            },
            imdbId: {
                type: String,
                required: true,
            },
            selectedQuoteIndex: {
                type: [String, Number],
                required: true,
            },
        },

        mounted() {
            // this.focusBtn(); // NOT SURE WHY THIS DOESN'T WORK ON MOUNT, Used setTimeout for now
            setTimeout(()=> {
                this.$refs.focusBtn.$el.focus();
            }, 250);
        },
        methods: {
            // NOT SURE WHY THIS DOESN'T WORK ON MOUNT
            // focusBtn() {
            //     this.$nextTick( () => {
            //         this.$refs.focusBtn.$el.focus(); // this is different in this version of Vuetify vs. latest v2.6.2
            //     })
            // },
            closeModal() {
                this.showModal = false;
                setTimeout(() => {
                    this.$emit('close-modal');
                }, 1000);
            },
        },
    };
</script>
